import { fetchJSON } from "../util/fetch";

export type Content = {
  [key in "de" | "en"]: {
    [key in "infoNoData"]: string
  };
}

export default class ContentStore {
  content: Content | undefined;
  constructor() {}

  async load(province: string): Promise<Content | undefined> {
    const url = `${config.apis.content}/${province}.json`;
    try {
      this.content = await fetchJSON(url, {});
    } catch (e) {
      this.content = undefined;
    }

    return this.content;
  }
}
